import React from 'react';
import { motion } from 'framer-motion';
import SliderMain from './TestiSlider';

const Testimonials = () => {
  return (
    <section id='testimonials' className='section bg-gradient-to-b from-black via-[#111] to-[#0d0d0d]'>
      <div className='section-separator' aria-hidden='true' />

      <div className='container mx-auto'>

        {/* ── Section header ── */}
        <motion.div
          className='flex flex-col items-center text-center mb-14'
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.55, ease: 'easeOut' }}
        >
          <span className='section-eyebrow'> </span>
          <h2 className='section-title mt-2 mb-3'>
            The Bookshelf
          </h2>
          <p className='text-paragraph max-w-[420px] text-[15px] leading-relaxed'>
            Books that shaped how I think about machines, math, and the future.
          </p>
        </motion.div>

        {/* ── Book grid ── */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-40px' }}
          transition={{ duration: 0.6, delay: 0.1, ease: 'easeOut' }}
        >
          <SliderMain />
        </motion.div>

      </div>
    </section>
  );
};

export default Testimonials;
